import { useEffect, useState, useCallback, useRef } from "react";
import BackImg from "@assets/images/stepsBack.jpg";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, FormControl } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";

const GoalFeedBack = ({ setFilterRecord, filterRecord }) => {
  const { t } = useTranslation();
  const [practices, setPractices] = useState([]);
  const [status, setStatus] = useState("🍎 Nutrition / Diet Goal");
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Refs for tracking
  const isFetchingRef = useRef(false);
  const scrollContainerRef = useRef(null);

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "N/A";

      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      };
      // en-GB gives dd/mm/yyyy
      return date.toLocaleDateString("en-GB", options);
    } catch (error) {
      return "N/A";
    }
  };

  return (
    <div
      className="py-4 px-4 rounded-lg bg-white h-full"
      // style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="flex items-center justify-between mb-2">
        <h2 className="font-medium text-[black] text-lg">Goal Feedback</h2>
        <FormControl sx={{ minWidth: 120 }}>
          <Select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            IconComponent={KeyboardArrowDown}
            sx={{
              borderRadius: "8px",
              backgroundColor: "transparent",
              background:
                "linear-gradient(150deg, #0771EF 12.89%, #15AAFC 85.22%)",
              "& .MuiSelect-select": {
                padding: "8px 16px",
                paddingRight: "32px !important",
                color: "#fff",
                fontSize: "16px",
                fontWeight: 500,
                textAlign: "center",
                backgroundColor: "transparent !important",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "none",
              },
              "& .MuiSvgIcon-root": {
                color: "#fff",
                right: "8px",
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  borderRadius: "8px",
                  marginTop: "4px",
                  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                },
              },
            }}
          >
            <MenuItem
              value="🍎 Nutrition / Diet Goal"
              sx={{
                color: "black",
                fontSize: "14px",
                fontWeight: 400,
                "&:hover": {
                  backgroundColor: "rgba(5, 117, 230, 0.1)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(5, 117, 230, 0.2)",
                },
              }}
            >
              🍎 Nutrition / Diet Goal
            </MenuItem>
            <MenuItem
              value="🏋️ Exercise / Activity Goal"
              sx={{
                color: "black",
                fontSize: "14px",
                fontWeight: 400,
                "&:hover": {
                  backgroundColor: "rgba(5, 117, 230, 0.1)",
                },
                "&.Mui-selected": {
                  backgroundColor: "rgba(5, 117, 230, 0.2)",
                },
              }}
            >
              🏋️ Exercise / Activity Goal
            </MenuItem>
          </Select>
        </FormControl>
      </div>

      {/* Custom scrollable container with ref */}
      <div className="bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] p-4 rounded-lg">
        <div
          ref={scrollContainerRef}
          className="bg-white rounded-[17px] space-y-3 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar border border-[0.5px] border-[#E6E6E6] rounded-lg p-3"
        >
          <div>{status}</div>
            {[1, 2, 3, 4, 5, 5].map(() => (
          <div className="border border-#E6E6E6 shadow-md p-4  rounded-[17px]">
              <div className="flex flex-col-reverse md:flex-row items-start gap-2 md:items-center justify-between mb-2">
                <p className="text-[#707070] text-[16px] font-[Lato] text-base whitespace-pre-line">
                  You stayed within your nutrition targets today — your
                  consistency is fueling real results.
                </p>
                <button
                  disabled
                  className="mb-2 md:mb-0 rounded-full py-2 px-4 text-[16px] font-[600] text-white font-medium whitespace-nowrap"
                  style={{
                    background:
                      "linear-gradient(150deg, #0771EF 12.89%, #15AAFC 85.22%)",
                  }}
                >
                  {formatDate("10/12/2025")}
                </button>
              </div>
          </div>
            ))}

          {/* {!hasMore && practices.length > 0 && (
          <div className="text-white text-center py-4">All practices loaded</div>
        )} */}
        </div>
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 12px;
        }

        .custom-scrollbar::-webkit-scrollbar-track {
          background-color: #fff !important;
          border-radius: 10px;
          margin: 4px 0;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: linear-gradient(150deg, #0771ef 12.89%, #15aafc 85.22%);
          border-radius: 10px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.3);
        }
      `}</style>
    </div>
  );
};

export default GoalFeedBack;
